import { checkValidityInn, renderLengthFieldRule, renderRequiredRule, renderValidator } from '@/utils/renderRulesForm';

export default (sender) => ({
  cityFrom: [renderRequiredRule('Пожалуйста выберите город', 'change')],
  senderZaborType: [
    renderRequiredRule('Пожалуйста выберите опцию'),
    {
      validator: (rule, value, callback) => {
        if (sender.cargoTransportationCustomer && value === '') {
          callback(new Error('Пожалуйста выберите опцию'));
        }
        callback();
      },
      trigger: 'change',
    },
  ],
  addressCargoPickup: [
    {
      validator: (rule, value, callback) => {
        if (sender.senderZaborType === 'Забор груза') {
          if (!sender.addressCargoPickup && !sender.detailsPickup) {
            callback(new Error('Введите адрес'));
          }
          if (!sender.pickUpDate) {
            callback(new Error('Некорректный временной интервал'));
          }
        } else {
          if (!sender.addressCargoPickup) {
            callback(new Error('Введите адрес'));
          }
        }
        callback();
      },
      trigger: 'change',
    },
    {
      validator: (rule, value, callback) => {
        if (sender.senderZaborType === 'Забор груза') {
          if (!sender.addressCargoPickup && !sender.detailsPickup) {
            callback(new Error('Введите адрес'));
          }
          if (!sender.pickUpDate) {
            callback(new Error('Некорректный временной интервал'));
          }
        } else {
          if (!sender.addressCargoPickup) {
            callback(new Error('Введите адрес'));
          }
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  senderType: [],
  innSender: [
    renderRequiredRule('Пожалуйста введите ИНН', 'change'),
    renderValidator({
      validatorFunc: checkValidityInn,
      message: 'Некорректно введён ИНН',
    }),
    renderLengthFieldRule({
      min: 10,
      max: 12,
      message: 'ИНН должен состоять от 10 до 12 символов',
    }),
  ],
  name: [renderRequiredRule('Пожалуйста введите название организации', 'change')],
  fioSender: [
    renderRequiredRule('Введите ФИО', 'change'),
    {
      validator: (rule, value, callback) => {
        value
          .trim()
          .split(' ')
          .forEach((value) => {
            if (value.length < 2) {
              callback(new Error('Слишком коротко'));
              return;
            }
          });

        callback();
      },
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        if (value.trim().split(' ').length !== 3) {
          callback(new Error('Некорректное ФИО'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  // PhoneCountry.Any => Regex.IsMatch(phone, @"^7[0346789]{1}\d{9}$"),
  phoneSender: [
    renderRequiredRule('Введите телефон', 'change'),
    renderValidator({
      validatorFunc: (value) => !!value.match(/^\+{0,1}\d \([346-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: 'Некорректно введён номер',
    }),
  ],

  // @"(^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,}$)|(^([а-яa-z0-9_-]+\.)*[а-яa-z0-9_-]+@[а-я0-9_-]+(\.[а-я0-9_-]+)*\.[а-я]{2,}$)";
  emailSender: [
    {
      validator: (rule, value, callback) => {
        if (
          (sender.senderType && value === '') ||
          (!(value === '') && !value.match(/(^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,}$)|(^([а-яa-z0-9_-]+\.)*[а-яa-z0-9_-]+@[а-я0-9_-]+(\.[а-я0-9_-]+)*\.[а-я]{2,}$)/))
        ) {
          callback(new Error('Пожалуйста введите почту'));
        }
        // else if (!value.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        //   callback(new Error("Почта введена неверно"));
        // }
        callback();
      },
      trigger: 'blur',
    },
    // renderValidator({
    //   validatorFunc: (value) =>
    //     !!value.match(
    //       /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    //     ) ,
    //   message: "Пожалуйста введите почту",
    // }),
  ],
});
